import { vatFieldOptions } from './vatFieldOptions'
import { divideByFactor } from '../../../../utils/prices'

export const vatRateToVatOption = (vatRate?: number | null) => {
  if (!vatRate) {
    return vatFieldOptions[0]
  }
  return (
    vatFieldOptions.find(
      (option) => option.value === divideByFactor(vatRate),
    ) ?? vatFieldOptions[0]
  )
}
